import clientInit from './clientInit';
var CompareVersion = /* @__PURE__ */ (function () {
    function CompareVersion() {
        var _this = this;
        this.compare = function (curVersion, version) {
            var _a, _b;
            var inputVersionArr = version.split('.').map(Number);
            var curVersionArr = curVersion.split('.').map(Number);
            var maxLen = Math.max(inputVersionArr.length, curVersionArr.length);
            for (var i = 0; i < maxLen; i++) {
                var _curV = (_a = curVersionArr[i]) !== null && _a !== void 0 ? _a : 0;
                var _inpV = (_b = inputVersionArr[i]) !== null && _b !== void 0 ? _b : 0;
                if (_curV > _inpV) {
                    return true;
                }
                if (_curV < _inpV)
                    return false;
            }
            return true;
        };
        this.compare3387SDK = function (version) {
            var _a, _b, _c;
            if (!version || !navigator.userAgent.includes('3387'))
                return true;
            var inputVersionArr = version.split('.').map(Number);
            var curVersion = JSON.parse(((_a = clientInit.getSDKInfo()) === null || _a === void 0 ? void 0 : _a.device) || '{}').SDK_VERSION;
            var curVersionArr = curVersion.split('.').map(Number);
            var maxLen = Math.max(inputVersionArr.length, curVersionArr.length);
            for (var i = 0; i < maxLen; i++) {
                var _curV = (_b = curVersionArr[i]) !== null && _b !== void 0 ? _b : 0;
                var _inpV = (_c = inputVersionArr[i]) !== null && _c !== void 0 ? _c : 0;
                if (_curV > _inpV) {
                    return true;
                }
                if (_curV < _inpV)
                    return false;
            }
            return true;
        };
        this.compare3387APP = function (version) {
            var _a, _b;
            if (!version || !navigator.userAgent.includes('3387'))
                return true;
            var inputVersionArr = version.split('.').map(Number);
            var curVersion = clientInit.getAppInfo().version;
            var curVersionArr = curVersion.split('.').map(Number);
            var maxLen = Math.max(inputVersionArr.length, curVersionArr.length);
            for (var i = 0; i < maxLen; i++) {
                var _curV = (_a = curVersionArr[i]) !== null && _a !== void 0 ? _a : 0;
                var _inpV = (_b = inputVersionArr[i]) !== null && _b !== void 0 ? _b : 0;
                if (_curV > _inpV) {
                    return true;
                }
                if (_curV < _inpV)
                    return false;
            }
            return true;
        };
        this.compare4399AndroidSDK = function (version) {
            var _a;
            if (!version || !navigator.userAgent.includes('4399'))
                return true;
            var curVersion = JSON.parse(((_a = clientInit.getSDKInfo()) === null || _a === void 0 ? void 0 : _a.device) || '{}').SDK_VERSION;
            if (!curVersion) {
                return false;
            }
            return _this.compare(curVersion, version);
        };
        this.compare4399IosSDK = function (version) {
            var _a;
            if (!version || !navigator.userAgent.includes('4399'))
                return true;
            var curVersion = JSON.parse(((_a = clientInit.getSDKInfo()) === null || _a === void 0 ? void 0 : _a.device) || '{}').SDK_VERSION;
            return _this.compare(curVersion, version);
        };
    }
    return CompareVersion;
}());
export default new CompareVersion();
